//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { searchLabelsAutocomplete } from '@apis/gatewayMediaApi';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useSearchLabelsAutocompleteQuery = (query: string) =>
  useQuery({
    /**
     * The search labels autocomplete query is disabled without query
     * because we will fetch data only when the user searches for labels.
     */
    enabled: query.length > 0,
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsLabels,
      query,
    ],
    queryFn: async ({ signal }) => searchLabelsAutocomplete(query, { signal }),
    staleTime: FIVE_MINUTES_STALE_TIME,
  });
